import { Component, input } from '@angular/core';
import { ReviewAdditionalServicesSummary } from '../../../review-and-pay/sections/review-additional-services-summary/review-additional-services-summary';
import { ReviewAddressSummary } from '../../../review-and-pay/sections/review-address-summary/review-address-summary';
import { ReviewInductionSummary } from '../../../review-and-pay/sections/review-induction-summary/review-induction-summary';
import { ReviewPackagingSummary } from '../../../review-and-pay/sections/review-packaging-summary/review-packaging-summary';
import type { ReviewAdditionalServicesView } from '../../../review-and-pay/utils/map-review-additional-services';
import type {
  ReviewAddressView,
  ReviewReturnAddressView,
} from '../../../review-and-pay/utils/map-review-address';
import type { ReviewInductionView } from '../../../review-and-pay/utils/map-review-induction';
import type { ReviewPackagingView } from '../../../review-and-pay/utils/map-review-packaging';

/** Expanded shipment-details panel with read-only summary cards. */
@Component({
  selector: 'app-get-labels-shipment-details',
  imports: [
    ReviewAdditionalServicesSummary,
    ReviewAddressSummary,
    ReviewInductionSummary,
    ReviewPackagingSummary,
  ],
  templateUrl: './get-labels-shipment-details.html',
  styleUrl: './get-labels-shipment-details.scss',
})
export class GetLabelsShipmentDetails {
  readonly shipFromView = input<ReviewAddressView | null>(null);
  readonly shipToView = input<ReviewAddressView | null>(null);
  readonly returnView = input<ReviewReturnAddressView | null>(null);
  readonly packagingView = input<ReviewPackagingView | null>(null);
  readonly additionalServicesView = input<ReviewAdditionalServicesView | null>(null);
  readonly inductionView = input<ReviewInductionView | null>(null);
  readonly locatorUrl = input('');
}
